import { createStyles, makeStyles } from '@mui/styles'
/*
Copyright 2022-06-16 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega styles para CarrierSearch
*/
export const useStyles = makeStyles(() =>
  createStyles({
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: '20px',
      marginBottom: '20px'
    },
    filters: {
      display: 'flex',
      flex: 3,
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    actions: {
      display: 'flex',
      flex: 3,
      justifyContent: 'flex-end',
      alignContent: 'center'
    }
  })
)
